var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8074_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1042 0H3.89583C2.86294 0.00112495 1.87267 0.411939 1.14231 1.14231C0.411939 1.87267 0.00112495 2.86294 0 3.89583L0 13.1042C0.00112495 14.1371 0.411939 15.1273 1.14231 15.8577C1.87267 16.5881 2.86294 16.9989 3.89583 17H13.1042C14.1371 16.9989 15.1273 16.5881 15.8577 15.8577C16.5881 15.1273 16.9989 14.1371 17 13.1042V3.89583C16.9989 2.86294 16.5881 1.87267 15.8577 1.14231C15.1273 0.411939 14.1371 0.00112495 13.1042 0ZM7.08333 9.91667V7.08333H9.91667V9.91667H7.08333ZM9.91667 12.0417V14.875H7.08333V12.0417H9.91667ZM2.125 7.08333H4.95833V9.91667H2.125V7.08333ZM7.08333 4.95833V2.125H9.91667V4.95833H7.08333ZM12.0417 7.08333H14.875V9.91667H12.0417V7.08333ZM14.875 3.89583V4.95833H12.0417V2.125H13.1042C13.5738 2.125 14.0242 2.31157 14.3563 2.64367C14.6884 2.97576 14.875 3.42618 14.875 3.89583ZM3.89583 2.125H4.95833V4.95833H2.125V3.89583C2.125 3.42618 2.31157 2.97576 2.64367 2.64367C2.97576 2.31157 3.42618 2.125 3.89583 2.125ZM2.125 13.1042V12.0417H4.95833V14.875H3.89583C3.42618 14.875 2.97576 14.6884 2.64367 14.3563C2.31157 14.0242 2.125 13.5738 2.125 13.1042ZM13.1042 14.875H12.0417V12.0417H14.875V13.1042C14.875 13.5738 14.6884 14.0242 14.3563 14.3563C14.0242 14.6884 13.5738 14.875 13.1042 14.875Z",
    fill: "#A1AAB4",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8074_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.e60bc3eb48cc8e7b675660b1b9dfcd5b.svg";
export { ForwardRef as ReactComponent };